<template>
  <div style="height: 100%">
    <Header
      dense
      icon="mdi-record-circle-outline"
      subtitle="Grabación"
      :title="actualSpot.name ? `${actualSpot.spotCode} - ${actualSpot.name}` : `${actualSpot.spotCode}`"
      :title-size="16"
      @back="onBackAction"
    />
    <div class="d-flex" style="height: 100%">
      <div
        class="d-flex full-width"
        style="padding: 20px; gap: 12px; width: 100%"
      >
        <v-col
          v-if="audios.editAudio == false"
          class="ma-0 pa-0"
          :class="
            mediaType === 'MEGAFONIA' || mediaType === 'RADIO'
              ? 'spotText-editor'
              : 'ghost-spotText-editor'
          "
          style="position: relative"
        >
          <vue-editor
            v-if="showOverlay == false"
            ref="quillEditor"
            :value="textSpotSpeaker"
            :editorToolbar="customToolbar"
            class="box-text editor"
            @text-change="changingTextSpotTech"
            :disabled="isRecording == true || this.actualSpot?.session == true"
            @focus="editingText = true"
            @blur="editingText = false"
            style="height: 80%"
          />
          <v-overlay v-if="roleChangingTxt === 'slave_plus' || roleChangingTxt === 'slave_plus_remote'" absolute>
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                El Creativo está escribiendo
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="admiraGreen"
                  indeterminate
                  buffer-value="0"
                  stream
                  reverse
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-overlay>
        </v-col>
        <AudioMaster
          v-if="(mediaType === 'MEGAFONIA' || mediaType === 'RADIO') && showRecorder == true"
          :key="audioMasterKey"
          ref="audioMaster"
          :audios="audios"
          :audioStatus="actualStatus"
          :updateAudioStatus="updateAudioStatus"
          :dataspot="dataspot"
          :falseSpot="falseSpot"
          :langToMp3="langToMp3"
          :sendDatatoback="sendDatatoback"
          :fromSession="fromSession"
          :goBack="goBack"
        />
      </div>

      <div v-if="audios.editAudio == false" style="position: relative;">
        <RecordingInfo class="recording-info"/>
        <v-btn class="toggle-btn" @click.stop="drawer = !drawer" color="admiraGreen">
          <v-icon>
            mdi mdi-information
          </v-icon>
        </v-btn>
      </div>
    </div>

    <v-overlay color="background" opacity="0.5" absolute :value="audios.isEncoding">
      <div class="text-center">
        <h3 class="text--primary">Codificando audio</h3>
        <p class="text--primary">Por favor espere, no cierre esta pantalla</p>
        <v-progress-circular indeterminate color="admiraGreen" size="64"></v-progress-circular>
      </div>
    </v-overlay>

    <v-overlay color="background" opacity="1" absolute :value="showOverlay">
      <div v-if="showReturnMessage == false">
        <h3 class="text--primary">Por favor espere</h3>
        <p class="text--primary">Cargando audio</p>
        <v-chip
          :color="connectedToTechnician ? '#749948' : 'disabled'"
          class="py-4 px-5 mb-4"
          text-color="white"
          style="font-size: 14px; border-radius: 22px"
        >
          <v-icon small left>
            {{
              connectedToTechnician ? "mdi-eye-outline " : "mdi-eye-off-outline"
            }}
          </v-icon>
          Técnico
        </v-chip>
        <v-progress-linear
          color="admiraGreen"
          indeterminate
          rounded
          height="7"
        ></v-progress-linear>
      </div>

      <div v-else>
        <h3 class="text--primary">No se ha encontrado el archivo de audio</h3>
        <v-btn class="justify-center admiraGreen mt-5" rounded depressed small dark width="" @click="onBackAction">Volver a la
        lista
        </v-btn>
      </div>
    </v-overlay>
    <FloatingPanel
      v-show="this.actualSpot?.session != true && audios.editAudio == false"
      :setSpot="setSpot"
      :falseSpot="falseSpot"
      :goBack="goBack"
      :isRecording="audios.isRecording"
      :editAudio="audios.editAudio"
      :textSpotSpeaker="textSpotSpeaker"
      :auxTextSpot="auxTextSpot"
      :saveText="saveText"
      :editingText="editingText"
    />
    <v-navigation-drawer v-model="drawer"
          absolute
          right
          temporary>
          <RecordingInfo/>
        </v-navigation-drawer>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { VueEditor, Quill } from "vue2-editor";

const Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block);

export default {
  components: {
    VueEditor,
    Header: defineAsyncComponent(() => import("../components/Header.vue")),
    AudioMaster: defineAsyncComponent(() =>
      import("../components/AudioMaster.vue")
    ),
    FloatingPanel: defineAsyncComponent(() =>
      import("../components/FloatingPanel.vue")
    ),
    RecordingInfo: defineAsyncComponent(() =>
      import("../components/RecordingInfo.vue")
    ),
  },
  data() {
    return {
      audioMasterKey: 0,
      actualStatus: "",
      audios: {
        masterBuffer: [],
        encodedBuffer: [],
        editAudio: false,
        loadingAudio: true,
        isRecording: false,
        isEncoding: false,
      },
      criLang: "",
      dataspot: null,
      mediaType: "",
      nameLang: "",
      loadingAudio: true,
      showRecorder: false,
      urlput: "",
      falseSpotUrlPut: "",
      customToolbar: [["link", "underline", "italic", "bold"]],
      isRecording: false,
      editingText: false,
      langToMp3: null,
      fromSession: false,
      drawer: false,
      showReturnMessage: false,
      hasMaster:false,
      savingText: false,
      saveTextSuccess: false,
      pendingSpotData: null,
    };
  },
  computed: {
    ...mapState([
      "actualSpot",
      "actualActivity",
      "connectedToTechnician",
      "port",
      "studio",
      "textSpotSpeaker",
      "roleChangingTxt",
      "role",
      "listSpots",
      "updateSpotList",
      "tabSelected",
      "currentCitation",
      "currentSpeakerGroup",
    ]),
    ...mapGetters(["checkMedia"]),

    falseSpot() {
      return this.actualSpot?.idAdmira == undefined;
    },
    showOverlay() {
      return this.audios.loadingAudio == true && this.showRecorder == false
    }
  },
  methods: {
    ...mapMutations(["setTextSpotSpeaker"]),
    ...mapActions(["sendTextSpot"]),

    setSpot() {
      this.clearPreviousResources(); // Limpia los recursos previos
      this.audioMasterKey += 1; 
      this.audios = {
        masterBuffer: [],
        encodedBuffer: [],
        editAudio: false,
        loadingAudio: true,
        isRecording: false,
        isEncoding: false,
      },
      this.showRecorder = false
      const {
        mediaType,
        spotCode: code,
        taskId,
        mediaId,
        texts,
          recordingStatus,
      } = this.actualSpot;

      this.audios.loadingAudio = true;

      this.mediaType = mediaType;
      this.portsend = this.port;

      this.currentSpot = this.actualSpot.spotCode;
      this.pendingSpotData = { mediaType, code, taskId, mediaId, texts };


      // if (this.actualSpot.texts.criteria?.id === undefined) {
      //   this.audios.loadingAudio = false;
      // }
      this.actualStatus = recordingStatus;
      // this.setCriId(texts.criteria.id);
      this.criLang = texts.criteria.id;
      this.nameLang = texts.criteria.name;

      // Al empezar a cargar una cuña ocultamos el contenido en los slaves
      // (data: false). El slave solo lo vuelve a mostrar cuando el master termina
      // de cargar todo: en ese momento el watcher de `showOverlay` emite
      // statusShowingRecorder(true). Así el slave nunca muestra una cuña a medio cargar.
      this.$globalData.socket.emit("statusShowingRecorder", {
        toNamespace: "ECI_ESTUDIO",
        toRoom: `estudio${this.studio}`,
        data: false,
      });
      this.status = "pending encoding";
      this.recordingDate = Date.now();
      this.dataspot = {
        status: this.status,
        studio: this.idStudio,
        duration: this.duration,
        recordingDate: null,
      };
      this.auxTextSpot = this.actualSpot.texts.text;
      this.setTextSpotSpeaker(this.actualSpot.texts.text);

      this.$nextTick(() => {
        this.$globalData.socket.emit("textRecording", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: this.actualSpot.texts.text,
        });
      });

      if (this.mediaType == "MEGAFONIA") {
        this.obtenerData(this.criLang, this.port).then((data) => {
          this.langToMp3 = data
          this.sendDatatoback(this.langToMp3);
          this.setAudioInfo()
        });
      } else if (this.mediaType == "RADIO") {
        this.sendDatatoback(null);
        this.setAudioInfo()
      } else {
        this.$nextTick(() => {
          this.audios.loadingAudio = false;
        });
      }
    },
    clearPreviousResources() {
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
      this.audios.masterBuffer = [];
      this.audios.encodedBuffer = [];
    },
    sendDatatoback(langtomp3) {
      const sinHtml = this.deleteHTML(this.textSpotSpeaker);
      const audioMaster = this.$refs.audioMaster
      const dataToSend = {
        lufs: audioMaster == undefined ? null : audioMaster.lufs,
        limit: audioMaster == undefined ? null : audioMaster.limit,
        currentSpot: this.actualSpot.idAdmira == undefined
            ? this.actualSpot.spotCode
            : this.actualSpot.realSpotCode,
        criLang:
          this.mediaType !== "MEGAFONIA"
            ? ""
            : this.langToMp3,
        mediatypesend: this.mediaType,
        radiodest: this.actualSpot.centerDestination,
        radiotext: sinHtml,
        codeid: this.actualSpot.spotCode
      };
      window.ipcRenderer.send("normalize-audio-data", dataToSend);
    },

    async obtenerData(langvariable, portsend) {
      try {
        let response = await this.$axios.get(
          `/api/v1/spots/langCode/${langvariable}`
        );

        return response.data.data;
      } catch (error) {
        console.error(`Hubo un error al obtener los datos: ${error.message}`);
        return null;
      }
    },
    deleteHTML(texto) {
      return texto.replace(/<[^>]+>/g, "");
    },

    async setAudioInfo() {
      //Asignar la URL
      this.urlput = `/api/v1/spots/${this.actualSpot._id}/recording/`;

      this.setAudioStatus();
    },
    async updateAudioStatus(payload) {
      try {
        const response = await this.$axios.put(this.urlput, payload);
        this.actualStatus = response.data.data.status;
        this.setRecordings()
        return { success: true };
      } catch (error) {
        return { success: false, error };
      }
    },

    async setAudioStatus() {
      //Definir el estatus y obtener el audio basado en ello
      switch (this.actualStatus) {
        case "empty":
          this.textstatus = "Vacio";
          // Diferimos a $nextTick para que `showOverlay` (loadingAudio && !showRecorder)
          // registre la transición true -> false y dispare su watcher. Ese watcher es
          // quien emite saveDataSpot + statusShowingRecorder(true) al slave. En cuñas
          // "empty" todo se resolvía síncrono dentro de setSpot, la transición se
          // colapsaba, el watcher no disparaba y el slave quedaba en "Por favor espere".
          this.$nextTick(() => {
            this.audios.loadingAudio = false;
            this.showRecorder = true;
          });
          break;
        case "edited pending encoding":
        case "pending encoding":
        case "encoded":
          this.checkAudioMaster();
          break;
        case "encoded another session":
          this.checkAudioEncoded();
          break;
      }
    },

    checkAudioMaster() {
      this.hasMaster = false
      window.ipcRenderer.send("checkfilexist");
      window.ipcRenderer.receiveOnce("file-response", async (data) => {

        if(data !== null) this.hasMaster = true
        
        await this.checkfiles(data);
        this.checkAudioEncoded();
      });
    },
    checkAudioEncoded() {
      window.ipcRenderer.send("checkencodedfile");
      window.ipcRenderer.receiveOnce("file-response-encoded", async (data) => {
        if(data == null && this.actualSpot?.session == true && this.tabSelected == 0 && this.hasMaster == false) {
          this.showReturnMessage = true
          return
        }
        await this.checkfiles(data);
        this.audios.loadingAudio = false;
        this.showRecorder = true;
        this.$refs.audioMaster.setAudio();
      });
    },
    async checkfiles(data) {
      if (data) {
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        try {
          const arrayBuffer =
            data.buffer instanceof ArrayBuffer
              ? data.buffer
              : data.buffer.buffer.slice(
                  data.buffer.byteOffset,
                  data.buffer.byteOffset + data.buffer.byteLength
                );

          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
          if (data.type == 0) {
            this.audios.masterBuffer.push(audioBuffer);
          } else {
            this.audios.encodedBuffer.push(audioBuffer);
          }

          //console.log('MP3 file loaded and converted to AudioBuffer:', audioBuffer);
        } catch (error) {
          console.error(
            "Error decodificando el archivo de audio checkfile:",
            error
          );
        }
      } else {
        console.error("No se ha recibido datos del archivo.");
      }
    },

    changingTextSpotTech() {
      if (this.roleChangingTxt !== "slave_plus" && this.role !== "slave_plus" && this.roleChangingTxt !== 'slave_plus_remote') {
        if (this.firstEntryEditorT) {
          this.$nextTick(() => {
            if (this.$refs.quillEditor.quill.root.innerHTML) {
              this.debounceTextSpot(
                this.$refs.quillEditor.quill.root.innerHTML
              );
            }
          });
        } else {
          this.firstEntryEditorT = true;
        }
      }
    },
    async saveText() {
      if(this.actualSpot?.idAdmira == undefined && this.actualSpot.mediaType == "MEGAFONIA") return
      this.savingText = true;
      const data = {
        ...this.dataSaveSpot,
        text: this.$refs.quillEditor.quill.root.innerHTML,
      };
      this.auxTextSpot = this.$refs.quillEditor.quill.root.innerHTML;
      const response = await this.sendTextSpot(data);
      this.savingText = false;
      if (response.status == 200) {
        // this.$store.dispatch("manageSuccess", "Texto de cuña actualizado");
        this.setRecordings();
        this.saveTextSuccess = true;
        setTimeout(() => { this.saveTextSuccess = false; }, 1500);
      }
    },
    debounceTextSpot(text) {
      this.$globalData.socket.emit("textChangedBy", {
        toNamespace: "ECI_ESTUDIO",
        toRoom: `estudio${this.studio}`,
        data: this.role,
      });
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$globalData.socket.emit("textRecording", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: text,
        });
        this.$globalData.socket.emit("textChangedBy", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: "",
        });
      }, 650);
    },
    createDataSaveSpot(data) {
      if (this.actualSpot?.session == true) return;
      this.dataSaveSpot = data;
      this.dataSaveSpot.criLang = data.texts.criteria.id;
      this.dataSaveSpot.taskId = this.actualActivity.taskId;

      // Esta es la nueva funcionalidad del socket para enviar los proveedores al locutor/creativo/remoto
      const spotData = {
        ...data,
        arrProviders: this.currentCitation == null ? [] : this.currentCitation.speakerGroups.find(group => group._id == this.currentSpeakerGroup),
        currentIndex: this.currentIndex(),
        totalSpots: this.listSpots.length,
        mediaType: this.checkMedia,
        actualActivity: this.actualActivity,
      };
      this.$globalData.socket.emit("saveDataSpot", {toNamespace:"ECI_ESTUDIO", toRoom:`estudio${this.studio}`, data: {...spotData}});


    },
    async setRecordings() {
      for (let index = 0; index < this.listSpots.length; index++) {
        const spot = this.listSpots[index];
        if (spot._id == this.actualSpot._id) {
          this.listSpots[index].texts.text =
            this.$refs.quillEditor.quill.root.innerHTML;
          this.listSpots[index].recordingStatus = this.actualStatus
        }
      }
      this.$store.state.updateSpotList = false;
    },

    async goBack() {
      this.$globalData.socket.emit("unblockSpotRequest", {
        spotID: this.actualSpot.idAdmira,
      });
      if(this.$route.params.sessions !== true) {
        await this.saveText()
      }
      this.$store.state.actualSpot = null;
      if (this.isPlaying == true) {
        this.pauseAudio();
      }
      this.$globalData.socket.emit("getAllowCitation", {
        toNamespace: "ECI_ESTUDIO",
        toRoom: `estudio${this.studio}`,
        data: { acces: false, recording: null },
      });
      if (this.$store.state.path == "citationDetails") {
        this.$router.push({
          name: "citationDetails",
        });
      } else {
        this.$router.push({
          name: "sessions",
          params: { from: "showRecording" },
        });
      }
    },
    checkChanges() {
      this.$refs.audioMaster.checkChanges();
    },
    onBackAction() {
      if(this.audios.isEncoding == true) return
      if(this.audios.isRecording == true) return
      if(this.audios.editAudio == true) {
        this.checkChanges()
      }
      else {
        this.goBack()
      }
    },
    currentIndex() {
      if (!this.actualSpot) return -1;
      return this.listSpots.findIndex(
        spot => spot._id === this.actualSpot._id
      ) + 1;
    },
  },
  watch: {
    roleChangingTxt(newValue, oldValue) {
      if (
        newValue !== oldValue &&
        this.roleChangingTxt &&
        this.roleChangingTxt !== this.role
      ) {
        if (this.role === "slave_plus")
          this.$refs.quillEditorPlus.quill.root.blur();
        else if (this.role === "technician")
          this.$refs.quillEditor.quill.root.blur();
      }
    },
    updateSpotList() {
      if(this.updateSpotList == true) {
        this.saveText()
      }
    },
    textSpotSpeaker() {
      this.auxTextSpot = this.textSpotSpeaker
    },
    showOverlay(val) {
      if (!val) {
        this.createDataSaveSpot(this.pendingSpotData);
        this.$globalData.socket.emit("textRecording", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: this.actualSpot.texts.text,
        });
        this.$globalData.socket.emit("statusShowingRecorder", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: true,
        });
      }
    }
  },
  created() {
    if(this.$route.params.sessions == true) {
      this.fromSession = true
    }
    window.ipcRenderer.send('set-recording-view', true);
    this.setSpot();
  },
  beforeDestroy() {
    window.ipcRenderer.send('set-recording-view', false);
    if (this.debounce) clearTimeout(this.debounce);

    if(this.fromSession== false) {
      this.$refs.quillEditor.quill.root.blur();
    }
    this.$globalData.socket.emit("getAllowCitation", {
      toNamespace: "ECI_ESTUDIO",
      toRoom: `estudio${this.studio}`,
      data: { acces: false, recording: null },
    });

    this.$globalData.socket.emit("statusShowingRecorder", false);


    this.setTextSpotSpeaker("");
    this.modifiedAudioBuffers = [];
  },
};
</script>

<style>
.editor {
  height: calc(100vh);
}
/* #reader-slave .ql-container {
    font-size: inherit
} */
.ql-snow .ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button:focus,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow.ql-toolbar button:focus,
.ql-snow.ql-toolbar button:hover {
  color: var(--v-admiraGreen-base) !important;
}

.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter {
  stroke: var(--v-admiraGreen-base) !important;
}

.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill {
  fill: var(--v-admiraGreen-base) !important;
}

.ql-snow a {
  color: var(--v-admiraGreen-base) !important;
}

.ql-editor {
  color: #777;
  padding: 15px 20px 20px 20px !important;
  /* max-height: calc(100vh - 300px); */
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: break-spaces;
}

.ql-container.ql-snow {
  border: 0 !important;
  border-radius: 0 0 25px 25px;
  background: white;
}

.ql-toolbar.ql-snow {
  border: 0 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 25px 25px 0 0;
  background: #f5f5f5;
}
.spotText-editor {
  height: calc(100vh - 164px);
  min-width: 0;
  overflow: hidden;
}
.ghost-spotText-editor {
  height: calc(100vh - 164px);
  min-width: 0;
  overflow: hidden;
}

.save-text-btn {
  min-width: 110px !important;
  transition: background-color 0.3s;
}

.success-check {
  animation: pop-in 0.2s ease-out;
}

.recording-info {
  min-width: 300px;
}

@keyframes pop-in {
  0% { transform: scale(0.5); opacity: 0; }
  70% { transform: scale(1.2); }
  100% { transform: scale(1); opacity: 1; }
}

.toggle-btn {
  display: none;
  position: absolute;
  width: 50px;
  left: -90px;
  bottom: 130px;
  padding: 0;
}

@media only screen and (max-width: 1199px) {
  .toggle-btn {
    display: block;
  }
  .recording-info {
    display: none;
  }
}

</style>